var _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tik_tok",
    "data-name": "tik tok",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.633,
    height: 18.099,
    viewBox: "0 0 15.633 18.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(1.624 1.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M25.41,19.19v2.8c-.15,0-.331.03-.511.03a5.574,5.574,0,0,1-3.578-1.323v5.953A5.368,5.368,0,0,1,11.4,29.532a5.369,5.369,0,0,0,3.668,1.473,5.267,5.267,0,0,0,4.269-2.165,5.468,5.468,0,0,0,1.082-3.247V19.611A5.357,5.357,0,0,0,24,20.934a2.917,2.917,0,0,0,.511-.03V19.1a3.466,3.466,0,0,0,.782.09Z",
    transform: "translate(-11.4 -15.132)",
    fill: "#ff004f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M19.838,26.23v3.1a2.5,2.5,0,0,0-.661-.09A2.445,2.445,0,0,0,16.772,31.7a2.608,2.608,0,0,0,.15.842A2.5,2.5,0,0,1,15.9,30.559a2.445,2.445,0,0,1,2.405-2.465,2.345,2.345,0,0,1,.661.09V26.2h.18A5.1,5.1,0,0,1,19.838,26.23Z",
    transform: "translate(-14.547 -20.097)",
    fill: "#ff004f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M43.242,7.734A4.044,4.044,0,0,1,42.1,5.9h.722v.421A4.775,4.775,0,0,0,43.242,7.734Z",
    transform: "translate(-32.87 -5.9)",
    fill: "#ff004f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M22.72,9.9v1.8a2.751,2.751,0,0,1-.511.03,5.574,5.574,0,0,1-3.578-1.323v5.953A5.338,5.338,0,0,1,9.612,20.3,5.453,5.453,0,0,1,8.8,17.445,5.38,5.38,0,0,1,14,12.063v1.984a2.5,2.5,0,0,0-.661-.09,2.445,2.445,0,0,0-2.405,2.465,2.381,2.381,0,0,0,1.022,1.984,2.394,2.394,0,0,0,4.66-.842V5.9h2.195a3.891,3.891,0,0,0,1.142,1.834A4.124,4.124,0,0,0,22.72,9.9Z",
    transform: "translate(-7.958 -4.728)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M12.043,22.66v1.022a5.38,5.38,0,0,0-5.2,5.381,5.453,5.453,0,0,0,.812,2.856A5.442,5.442,0,0,1,6,27.981,5.37,5.37,0,0,1,11.351,22.6,4.935,4.935,0,0,1,12.043,22.66Z",
    transform: "translate(-6 -16.407)",
    fill: "#00f7ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M26.155,3.173H23.96v11.6a2.445,2.445,0,0,1-2.405,2.465A2.366,2.366,0,0,1,19.3,15.619a2.449,2.449,0,0,0,1.383.451,2.419,2.419,0,0,0,2.405-2.435V2H26v.06a1.464,1.464,0,0,0,.03.361A3.263,3.263,0,0,0,26.155,3.173Z",
    transform: "translate(-15.301 -2)",
    fill: "#00f7ef"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M48.6,13.052h0v1.082A4.117,4.117,0,0,1,45.8,12,3.9,3.9,0,0,0,48.6,13.052Z",
    transform: "translate(-33.834 -8.994)",
    fill: "#00f7ef"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tik tok.2e424ba225c5da30028ab23450d2835a.svg";
export { ForwardRef as ReactComponent };